/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelValue
 */
export interface LabelValue {
    /**
     * 
     * @type {string}
     * @memberof LabelValue
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof LabelValue
     */
    count: number;
}

/**
 * Check if a given object implements the LabelValue interface.
 */
export function instanceOfLabelValue(value: object): value is LabelValue {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function LabelValueFromJSON(json: any): LabelValue {
    return LabelValueFromJSONTyped(json, false);
}

export function LabelValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelValue {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'count': json['count'],
    };
}

export function LabelValueToJSON(value?: LabelValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'count': value['count'],
    };
}

